var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('main',[(_vm.isLoading)?_c('div',{staticClass:"h-screen flex items-center justify-center"},[_c('loading-spinner')],1):_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }